import getBlacklistDomains from './blacklist';
import { dataAttributes, selectors } from './lib';
import * as Validation from './validation';

export default async (form) => {
	window.blacklist = await getBlacklistDomains();

	form.querySelectorAll(selectors.field).forEach((field) => {
		const fieldType = field.getAttribute(dataAttributes.fieldType);

		if (['text', 'textarea', 'number', 'email', 'tel', 'url', 'password'].includes(fieldType)) {
			const input = field.querySelector(`input:not([${dataAttributes.fieldPattern}]), textarea:not([${dataAttributes.fieldPattern}])`);
			input?.addEventListener('focusout', () => Validation.validateInput(field));

			const patternInput = field.querySelector(`[${dataAttributes.fieldPattern}]`);
			patternInput?.addEventListener('input', () => Validation.validateMultiPattern(field));
		} else if (fieldType === 'multi_switch') {
			field.querySelectorAll('input').forEach((checkbox) => {
				checkbox.addEventListener('change', () => Validation.validateMultiSwitch(field));
			});
		} else if (fieldType === 'switch') {
			const checkbox = field.querySelector('input');
			checkbox.addEventListener('change', () => Validation.validateSwitch(field));
		} else if (fieldType === 'select') {
			const select = field.querySelector('select');
			select.addEventListener('change', () => Validation.validateSelect(field));
		} else if (fieldType === 'radio') {
			field.querySelectorAll('input').forEach((checkbox) => {
				checkbox.addEventListener('change', () => Validation.validateMultiRadio(field));
			});
		}
	});
};
